"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsActionFooterType = void 0;
const copy_1 = __importDefault(require("../../shared/copy"));
const analyticsUtils_1 = require("../../utils/analyticsUtils");
const partners_1 = require("../../utils/partners");
const navigation_1 = require("../../interfaces/navigation");
const constants_1 = require("../../utils/constants");
var AnalyticsActionFooterType;
(function (AnalyticsActionFooterType) {
    AnalyticsActionFooterType["About"] = "logo";
    AnalyticsActionFooterType["Buy"] = "buy";
    AnalyticsActionFooterType["Forums"] = "forums";
    AnalyticsActionFooterType["News"] = "news";
    AnalyticsActionFooterType["Sell"] = "sell";
    AnalyticsActionFooterType["Services"] = "services";
})(AnalyticsActionFooterType = exports.AnalyticsActionFooterType || (exports.AnalyticsActionFooterType = {}));
const FooterConfiguration = {
    advertisingPreferences: 'Advertising preferences',
    copyright: `© ${new Date().getFullYear()} Pistonheads Holdco Limited, All Rights Reserved`,
    sections: {
        buy: {
            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
            action: AnalyticsActionFooterType.Buy,
            path: `/${constants_1.Pages.SearchResultsPage}`,
            text: 'Buy',
            type: navigation_1.NavigationType.Buy,
            sections: [
                {
                    path: `/${constants_1.Pages.SearchResultsPage}`,
                    text: 'Search used cars',
                },
                {
                    path: '/classifieds/used-cars',
                    text: 'Browse used cars',
                },
                {
                    path: '/classifieds/used-cars/uk',
                    text: 'Used cars by location',
                },
                {
                    path: '/classifieds/used-cars/browse-all-makes',
                    text: 'All used car makes',
                },
                {
                    path: '/account/edituser',
                    text: 'Classifieds account',
                },
                {
                    path: 'https://pistonheads.shop',
                    text: 'PistonHeads Merchandise',
                },
            ].map((section) => (Object.assign(Object.assign({}, section), { category: analyticsUtils_1.AnalyticsCategoryType.FooterNavigation, action: AnalyticsActionFooterType.Buy, type: navigation_1.NavigationType.GenericLink }))),
        },
        sell: {
            category: analyticsUtils_1.AnalyticsCategoryType.FooterNavigation,
            action: AnalyticsActionFooterType.Sell,
            path: '/sell-my-car',
            text: navigation_1.NavigationType.Sell,
            type: navigation_1.NavigationType.Sell,
            sections: [
                {
                    path: '/sell-my-car',
                    text: 'Sell my car',
                },
            ].map((section) => (Object.assign(Object.assign({}, section), { category: analyticsUtils_1.AnalyticsCategoryType.FooterNavigation, action: AnalyticsActionFooterType.Sell, type: navigation_1.NavigationType.GenericLink }))),
        },
        news: {
            category: analyticsUtils_1.AnalyticsCategoryType.FooterNavigation,
            action: AnalyticsActionFooterType.News,
            path: '/news',
            text: 'News',
            type: navigation_1.NavigationType.News,
            sections: [
                {
                    path: '/regulars',
                    text: 'Regulars',
                },
                {
                    path: '/features',
                    text: 'Features',
                },
            ].map((section) => (Object.assign(Object.assign({}, section), { category: analyticsUtils_1.AnalyticsCategoryType.FooterNavigation, action: AnalyticsActionFooterType.News, type: navigation_1.NavigationType.GenericLink }))),
        },
        forums: {
            category: analyticsUtils_1.AnalyticsCategoryType.FooterNavigation,
            action: AnalyticsActionFooterType.Forums,
            path: '/gassing/',
            text: 'Forums',
            type: navigation_1.NavigationType.Forums,
            sections: [
                {
                    path: '/gassing/',
                    text: 'Forum home',
                },
                {
                    path: '/gassing/forum.asp?h=0&f=23',
                    text: 'General gassing',
                },
                {
                    path: '/gassing/mytopics.asp',
                    text: 'My stuff',
                },
                {
                    path: '/members/editProfile.asp',
                    text: 'Forums account',
                },
                {
                    path: '/rules-of-posting',
                    text: 'Rules of posting',
                },
            ].map((section) => (Object.assign(Object.assign({}, section), { category: analyticsUtils_1.AnalyticsCategoryType.FooterNavigation, action: AnalyticsActionFooterType.Forums, type: navigation_1.NavigationType.GenericLink }))),
        },
        services: {
            category: analyticsUtils_1.AnalyticsCategoryType.FooterNavigation,
            action: AnalyticsActionFooterType.Services,
            path: '',
            text: 'Services',
            type: navigation_1.NavigationType.ServicesTools,
            sections: [
                {
                    path: partners_1.financeUrlUnder30k,
                    rel: 'sponsored',
                    text: 'Car finance under £30K',
                },
                {
                    path: partners_1.financeUrlAbove30k,
                    rel: 'sponsored',
                    text: 'Car finance above £30K',
                },
                {
                    path: partners_1.insuranceUrl,
                    rel: 'sponsored',
                    text: 'Car insurance',
                },
                {
                    isOpenInNewWindow: true,
                    path: partners_1.gapInsuranceUrl,
                    rel: 'sponsored',
                    text: 'Gap insurance',
                },
            ].map((section) => (Object.assign(Object.assign({}, section), { category: analyticsUtils_1.AnalyticsCategoryType.FooterNavigation, action: AnalyticsActionFooterType.Services, type: navigation_1.NavigationType.GenericLink }))),
        },
        about: {
            category: analyticsUtils_1.AnalyticsCategoryType.FooterNavigation,
            action: AnalyticsActionFooterType.About,
            path: '/about-us',
            text: 'About',
            type: navigation_1.NavigationType.About,
            sections: [
                {
                    path: '/about-us',
                    text: 'About PistonHeads',
                },
                {
                    path: '/classifieds/used-cars',
                    text: 'Browse used cars',
                    hideDesktop: true,
                },
                {
                    path: '/contact',
                    text: 'Contact us',
                },
                {
                    path: '/terms-and-conditions',
                    text: 'Terms & conditions',
                },
                {
                    path: '/privacy-policy#p3',
                    text: 'Cookies policy',
                },
                {
                    path: '/privacy-policy',
                    text: 'Privacy policy',
                },
                {
                    path: '/pricing-policy',
                    text: 'Pricing policy',
                },
                {
                    path: 'https://link.pistonheads.com/join/63g/signup',
                    text: 'Sign up for our newsletter',
                },
                {
                    path: '/static-assets/CarGurus_FY21_Modern_Slavery_Statement.pdf',
                    text: 'UK Modern Slavery Statement',
                    isOpenInNewWindow: true,
                },
            ].map((section) => (Object.assign(Object.assign({}, section), { category: analyticsUtils_1.AnalyticsCategoryType.FooterNavigation, action: 'click', type: navigation_1.NavigationType.GenericLink }))),
        },
    },
    trademark: 'PistonHeads® is a registered trademark of CarGurus Ireland Limited',
    registeredAddress: copy_1.default.registeredAddress,
};
exports.default = FooterConfiguration;
//# sourceMappingURL=config.js.map